/* ==============================================================================================
 * MOBILE DEVICE DETECTION UTIL
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	/**
	 * @return {boolean}
	 */
	Sushi.Util.isMobile = function () {
		return window.innerWidth < 768;
	};

})(Sushi || (Sushi = {}));
